// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order_code[data-v-f64038a0]{cursor:pointer;color:#6296ff}", ""]);
// Exports
module.exports = exports;
